import React from "react";
import {ShowPermittedOnly} from "../../rights/ShowPermittedOnly.tsx";
import SupportContextPicker from "../../supportContext/SupportContextPicker.tsx";
import {useAppSelector} from "../../../hooks/reduxHooks.ts";

interface MainHeaderPageProps {
    children?: React.ReactNode;
    title?: string;
    /**
     * The area above the title, where the title names the tab inside it - otherwise
     * only the active tab says where one is (#55819).
     */
    eyebrow?: string;
    buttons?: React.ReactNode;
    noSupportContextPicker?: boolean;
}

const MainHeaderPage: React.FC<MainHeaderPageProps> = ({children, title, eyebrow, buttons, noSupportContextPicker}) => {
    // a running context is ended in its banner first, so the header offers no switch then
    const inSupportContext = !!useAppSelector(state => state.auth.supportContext);
    return (
        <div className="sticky top-0 z-40 bg-an-surface px-4 py-4 lg:py-6 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 lg:gap-4">
            <div className="flex flex-col min-w-0">
                {eyebrow && (
                    <span className="an-caption font-bold uppercase tracking-[0.08em] truncate">
                        {eyebrow}
                    </span>
                )}
                <h1
                    className="an-h1 truncate"
                    title={title}
                >
                    {title}
                </h1>
            </div>
            <div className="flex items-center gap-3 flex-wrap">
                {children}
                {buttons}
                {!noSupportContextPicker && !inSupportContext && (
                    <ShowPermittedOnly permission="SupportContext_write">
                        <SupportContextPicker/>
                    </ShowPermittedOnly>
                )}
            </div>
        </div>
    );
};

export default MainHeaderPage;
